import { render, staticRenderFns } from "./resource-echarts.vue?vue&type=template&id=045524c6&scoped=true"
import script from "./resource-echarts.vue?vue&type=script&lang=js"
export * from "./resource-echarts.vue?vue&type=script&lang=js"
import style0 from "./resource-echarts.vue?vue&type=style&index=0&id=045524c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045524c6",
  null
  
)

export default component.exports